import {FormattedTimestamp} from '../timestamp/formatted-timestamp';
import type {Format as FormattedTimestampFormat} from '../timestamp/formatted-timestamp';
import {RelativeTimestamp} from '../timestamp/relative-timestamp';
import {RELATIVE_TIMESTAMP_FORMATS} from '../timestamp/types';
import type {RelativeTimestampFormat} from '../timestamp/types';

type DatetimeFormat = {
    type: 'datetime';
    format?: FormattedTimestampFormat;
};

type RelativeFormat = {
    type: 'relative';
    format?: RelativeTimestampFormat;
};

export interface Props {
    datetime: number | null | undefined;
    prefix: string;
    emptyText: string;
    displayConfig?: DatetimeFormat | RelativeFormat;
    showDetailedPopover?: boolean;
}

export function StatusBarSecondaryTimestamp(props: Props) {
    if (!props.datetime && props.emptyText) {
        return <span className='flex'>{props.emptyText}</span>;
    }

    if (props.datetime) {
        return (
            <span className='flex'>
                {props.prefix}&nbsp;{' '}
                {props.displayConfig?.type === 'relative' ? (
                    <RelativeTimestamp
                        datetime={props.datetime}
                        format={props.displayConfig.format || RELATIVE_TIMESTAMP_FORMATS.FROM_NOW}
                    />
                ) : (
                    <FormattedTimestamp
                        datetime={props.datetime}
                        format={
                            props.displayConfig?.format ||
                            FormattedTimestamp.formats.longDateWithTime
                        }
                        showDetailedPopover={props.showDetailedPopover}
                    />
                )}
            </span>
        );
    }

    return null;
}
